export const close = () => (
  <path
    d="M18 6L6 18M6 6l12 12"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
